import { gql, TypedDocumentNode } from "@apollo/client";

import {
  ExistingUsersQuery,
  ExistingUsersQueryVariables,
} from "./GetExistingUsers.generated";

const GET_EXISTING_USERS: TypedDocumentNode<
  ExistingUsersQuery,
  ExistingUsersQueryVariables
> = gql`
  query existingUsers($emails: [String!]) {
    existingUsers(emails: $emails) {
      existingUsers {
        teams {
          name
        }
        account {
          uuid
          accountType
          stripeCustomerId
          isSubscribed
        }
        email
        firstName
        lastName
        uuid
      }
      newUsers
      deactivatedUsers
    }
  }
`;
export default GET_EXISTING_USERS;
